(function (angular) {
    'use strict';

    angular.module('customChannel')

        /**
         *
         */
        .factory('customChannelService',
            ['$http', '$q', 'portalConfig', 'sharedDataService', 'channelsProvider', 'customChannels', 'permissionService',
                function ($http, $q, portalConfig, sharedDataService, channelsProvider, customChannels, permissionService) {

                    var urlBase = portalConfig.urlBase;
                    // urlBase = 'http://localhost:8001';
                    var fac = {
                        getChannels: getChannels,
                        getPossibleChannels: getPossibleChannels,
                        getCustomChannels: getCustomChannels,
                        createCustomChannel: createCustomChannel,
                        updateCustomChannel: updateCustomChannel,
                        deleteCustomChannel: deleteCustomChannel
                    };

                    return fac;

                    function getPossibleChannels() {
                        if (sharedDataService.getPossibleChannels().length) {
                            return $q.resolve(sharedDataService.getPossibleChannels());
                        }
                        return $http.get(urlBase + "/channels")
                            .then(function (response) {
                                sharedDataService.setPossibleChannels(response.data);
                                response.data.forEach(function (channel) {

                                    if (channel.id.startsWith('custom_')) {
                                        channelsProvider[channel.id] = channel;
                                        channelsProvider[channel.id].permissionsRead = ['chan:r'];
                                        channelsProvider[channel.id].permissionsWrite = ['chan:w'];
                                    } else {
                                        let permissionsRead = channelsProvider[channel.id] && channelsProvider[channel.id].permissionsRead ? channelsProvider[channel.id].permissionsRead : undefined;
                                        let permissionsWrite = channelsProvider[channel.id] && channelsProvider[channel.id].permissionsWrite ? channelsProvider[channel.id].permissionsWrite : undefined;

                                        channelsProvider[channel.id] = channel;
                                        channelsProvider[channel.id].permissionsRead = permissionsRead;
                                        channelsProvider[channel.id].permissionsWrite = permissionsWrite;
                                    }

                                    if (channelsProvider[channel.id].permissionsRead) {
                                        channelsProvider[channel.id].allowed = permissionService.checkPermissions(channelsProvider[channel.id].permissionsRead)
                                    } else {
                                        channelsProvider[channel.id].allowed = true;
                                    }
                                });
                                return sharedDataService.getPossibleChannels();
                            })
                            .catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }
                    /**
                     * GET "/apispaces/{id}/channels/custom"
                     * @param {string} id - the api space Id
                     */
                    function getChannels(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/channels")
                            .then(getChannelsComplete)
                            .catch(getChannelsFailed);

                        function getChannelsComplete(response) {
                            return response.data;
                        }

                        function getChannelsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * GET "/apispaces/{id}/channels/custom"
                     * @param {string} id - the api space Id
                     */
                    function getCustomChannels(id) {
                        if (customChannels.data) {
                            return $q.resolve(customChannels.data);
                        }

                        return $http.get(urlBase + "/apispaces/" + id + "/channels/custom")
                            .then(getCustomChannelsComplete)
                            .catch(getCustomChannelsFailed);

                        function getCustomChannelsComplete(response) {
                            customChannels.data = response.data;
                            return response.data;
                        }

                        function getCustomChannelsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * POST "/apispaces/{id}/channels/custom"
                     * @param {string} id - the api space Id
                     * @param {object} data - the channel data
                     */
                    function createCustomChannel(id, data) {

                        return $http.post(urlBase + "/apispaces/" + id + "/channels/custom", data)
                            .then(createCustomChannelComplete)
                            .catch(createCustomChannelFailed);

                        function createCustomChannelComplete(response) {
                            customChannels.data = undefined;
                            return response.data;
                        }

                        function createCustomChannelFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * PUT "/apispaces/{id}/channels/custom"
                     * @param {string} id - the api space Id
                     * @param {object} data - the channel data
                     */
                    function updateCustomChannel(id, data) {

                        return $http.put(urlBase + "/apispaces/" + id + "/channels/custom/" + encodeURIComponent(data.id), data)
                            .then(updateCustomChannelComplete)
                            .catch(updateCustomChannelFailed);

                        function updateCustomChannelComplete(response) {
                            customChannels.data = undefined;
                            return response.data;
                        }

                        function updateCustomChannelFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * DELETE "/apispaces/{id}/channels/custom"
                     * @param {string} id - the api space Id
                     * @param {string} channelId - the channel id
                     */
                    function deleteCustomChannel(id, channelId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/channels/custom/" + encodeURIComponent(channelId))
                            .then(deleteCustomChannelComplete)
                            .catch(deleteCustomChannelFailed);

                        function deleteCustomChannelComplete(response) {
                            customChannels.data = undefined;
                            return response.data;
                        }

                        function deleteCustomChannelFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);
